import * as React from "react";

function SvgZendesk(props, ref) {
  return (
    <svg
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      width="1em"
      height="1em"
      {...{ ...props, ref }}
    >
      <path d="M11.085 21.095H0L11.085 7.712v13.383zm12.915 0H12.915a5.54 5.54 0 015.543-5.543A5.541 5.541 0 0124 21.095zm-11.085-4.804V2.905H24L12.915 16.291zm-1.83-13.386A5.544 5.544 0 010 2.907h11.085v-.002z" />
    </svg>
  );
}

export default React.forwardRef(SvgZendesk);
